import { Fragment, type Node as ProseMirrorNode } from "@tiptap/pm/model";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Extension } from "@tiptap/react";

const ATTACHMENT_MENTION_PATTERN = /@\[(.+?)\]\(attachment:([^)]+)\)/g;

export const AttachmentMentionPaste = Extension.create({
  name: "attachmentMentionPaste",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("attachmentMentionPaste"),
        props: {
          handlePaste: (view, event) => {
            const mentionType = view.state.schema.nodes.mention;
            if (!mentionType) return false;

            const text = event.clipboardData?.getData("text/plain");
            if (!text || !ATTACHMENT_MENTION_PATTERN.test(text)) return false;
            ATTACHMENT_MENTION_PATTERN.lastIndex = 0;

            const nodes: ProseMirrorNode[] = [];
            let lastIndex = 0;
            let match = ATTACHMENT_MENTION_PATTERN.exec(text);

            while (match) {
              const [fullMatch, label, attachmentId] = match;
              const prefix = text.slice(lastIndex, match.index);
              if (prefix.length > 0) {
                nodes.push(view.state.schema.text(prefix));
              }

              nodes.push(
                mentionType.create({
                  id: attachmentId,
                  label,
                  mentionType: "uploadedDocument",
                })
              );
              nodes.push(view.state.schema.text(" "));

              lastIndex = match.index + fullMatch.length;
              match = ATTACHMENT_MENTION_PATTERN.exec(text);
            }

            const suffix = text.slice(lastIndex);
            if (suffix.length > 0) {
              nodes.push(view.state.schema.text(suffix));
            }

            if (nodes.length === 0) return false;

            const { from, to } = view.state.selection;
            const transaction = view.state.tr.replaceWith(from, to, Fragment.fromArray(nodes));
            view.dispatch(transaction);
            return true;
          },
        },
      }),
    ];
  },
});
